import * as React from "react";
import { Route, Switch } from "react-router-dom";
import List from "./Ops.Payments.List";
import Summary from "./Ops.Payments.Summary";
import Details from "./Ops.Payments.Details";
import PayRequests from "./Ops.Payments.PayRequests";
import Pay from "./Ops.Payments.Pay";

const Payments = props => (
  <Switch>
    <Route
      exact={true}
      path="/snapscan/ops/payments"
      render={routerProps => <List {...{ ...props, ...routerProps }} />}
    />
    <Route
      exact={true}
      path="/snapscan/ops/payments/:id/summary"
      render={routerProps => <Summary {...{ ...props, ...routerProps }} />}
    />
    <Route
      exact={true}
      path="/snapscan/ops/payments/:id/details"
      render={routerProps => <Details {...{ ...props, ...routerProps }} />}
    />
    <Route
      exact={true}
      path="/snapscan/ops/payments/:id/pay_requests"
      render={routerProps => <PayRequests {...{ ...props, ...routerProps }} />}
    />
    <Route
      exact={true}
      path="/snapscan/ops/payments/:id/pay"
      render={routerProps => <Pay {...{ ...props, ...routerProps }} />}
    />
  </Switch>
);

export default Payments;
